import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import "core-js/modules/es.array.push.js";
import { defineComponent, ref, computed, onMounted, watch } from 'vue';
import { httpPost } from '@/api/request';
const md5 = require('./md5.min.js');
export default defineComponent({
  name: 'Translate',
  setup() {
    const LANGUAGE_ENGLISH_MAP = new Map([['zh', 'Chinese (Simplified)'], ['t', 'Chinese (Traditional)'], ['en', 'English'], ['de', 'German'], ['fr', 'French'], ['es', 'Spanish'], ['ja', 'Japanese'], ['ko', 'Korean']]);
    const switchImg = require('@/assets/images/translate-switch.png');
    const TRANSLATE_URL = '/translateConnection/batch/v2/get/result';
    const LANGUAGE_IDENTIFICATION_URL = '/translateConnection/v2/languageIdentification';
    const SUPPORT_LANGUAGE_URL = '/translateConnection/v2/supportLanguageInfo';
    const leftLanguage = ref('');
    const rightLanguage = ref('');
    const identifyLanguage = ref('');
    const tranDomain = ref('');
    const translateOrigin = ref('');
    const languageInfo = ref('');
    const translateResult = ref([]);
    const isTranslating = ref(false);
    const isUrl = ref(false);
    const inInput = ref(true);
    let inputTimer = null;
    const copyTxt = ref('');
    const isChoosed = ref(false);
    const showMessage = ref(false);
    const leftLanguage2 = ref('');
    const isShowPrivacyTip = ref(false);
    const rightLanguageIsChoosed = ref(false);
    const patentDisabled = ref(false);
    const announcementDisabled = ref(false);
    const leftTextAreaStyle = ref({
      direction: 'ltr'
    });
    const rightTextAreaStyle = ref({
      wordBreak: 'keep-all',
      textAlign: 'left',
      direction: 'ltr'
    });
    const fromLanguageList = ref([]);
    const toLanguageList = ref([]);
    const fromLanguages = computed(() => {
      const fromList = [];
      for (const index in fromLanguageList.value) {
        fromList.push({
          label: fromLanguageList.value[index].zhName,
          value: fromLanguageList.value[index].value
        });
      }
      return fromList;
    });
    const toLanguages = computed(() => {
      const toList = [];
      for (const index in toLanguageList.value) {
        if (toLanguageList.value.hasOwnProperty(index)) {
          toList.push({
            label: toLanguageList.value[index].zhName,
            value: toLanguageList.value[index].value
          });
        }
      }
      return toList;
    });
    const domains = computed(() => {
      const domains = [{
        label: 'Currency Domain',
        value: 'default'
      }];
      if (leftLanguage.value === 'auto' || leftLanguage.value === 'zh' && rightLanguage.value === 'en') {
        domains.push({
          label: 'Patent Domain',
          value: 'patent'
        });
      }
      if (leftLanguage.value === 'auto' || leftLanguage.value === 'en' && rightLanguage.value === 'zh') {
        domains.push({
          label: 'Announcement Domain',
          value: 'announcement'
        });
      }
      return domains;
    });
    onMounted(() => {
      leftLanguage.value = 'auto';
      rightLanguage.value = 'en';
      copyTxt.value = 'copy';
      tranDomain.value = 'default';
      init();
    });
    watch(translateOrigin, newValue => {
      if (newValue === '') {
        translateResult.value = [];
      }
    });
    watch(leftLanguage, newValue => {
      if (newValue !== 'auto' && newValue !== '') {
        // 非用户选择带"检测到",用户选择不带"检测到"
        leftLanguage2.value = (!isChoosed.value ? 'identify:' : '') + LANGUAGE_ENGLISH_MAP.get(leftLanguage.value);
      } else {
        leftLanguage2.value = '自动识别';
      }
      if (newValue === 'ar') {
        leftTextAreaStyle.value.direction = 'rtl';
      } else {
        leftTextAreaStyle.value.direction = 'ltr';
      }
      checkDomainDisabled();
    });
    watch(rightLanguage, () => {
      checkDomainDisabled();
    });
    function init() {
      httpPost(SUPPORT_LANGUAGE_URL, {}).then(res => {
        if (res.code === 0) {
          isTranslating.value = false;
          const result = res.data;
          fromLanguageList.value = result.from;
          toLanguageList.value = result.to;
          for (const index in fromLanguageList.value) {
            LANGUAGE_ENGLISH_MAP.set(fromLanguageList.value[index].value, fromLanguageList.value[index].zhName);
          }
          for (const index in toLanguageList.value) {
            LANGUAGE_ENGLISH_MAP.set(toLanguageList.value[index].value, toLanguageList.value[index].zhName);
          }
        }
      });
    }
    function checkDomainDisabled() {
      checkPatentDisabled();
      checkAnnouncementDisabled();
    }
    function checkPatentDisabled() {
      if (leftLanguage.value !== 'zh' || rightLanguage.value !== 'en') {
        if (tranDomain.value === 'patent') {
          tranDomain.value = 'default';
          _message.warning('The patent domain currently only supports Chinese - to - English translation, and the domain has been automatically switched to the current domain');
        }
        patentDisabled.value = true;
      }
      if (leftLanguage.value === 'auto' || leftLanguage.value === 'zh' && rightLanguage.value === 'en') {
        patentDisabled.value = false;
      }
    }
    function checkAnnouncementDisabled() {
      if (leftLanguage.value !== 'en' || rightLanguage.value !== 'zh') {
        if (tranDomain.value === 'announcement') {
          tranDomain.value = 'default';
          _message.warning('The announcement domain currently only supports English - to - Chinese translation, and the domain has been automatically switched to the current domain');
        }
        announcementDisabled.value = true;
      }
      if (leftLanguage.value === 'auto' || leftLanguage.value === 'en' && rightLanguage.value === 'zh') {
        announcementDisabled.value = false;
      }
    }
    // function clear() {
    //   translateOrigin.value = ''
    // }
    function chooseLan(value) {
      if (value === 'auto') {
        showMessage.value = false;
      }
      isChoosed.value = value !== 'auto';
      leftLanguage.value = value;
    }
    function chooseRightLan() {
      rightLanguageIsChoosed.value = true;
    }
    function changeLeftLan(value) {
      leftLanguage.value = value;
      showMessage.value = false;
    }
    function copy() {
      const oInput = document.createElement('textarea');
      oInput.value = translateResult.value.join('\n');
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand('Copy'); // 执行浏览器复制命令
      document.body.removeChild(oInput);
    }
    /** 交换语种 */
    function exchange() {
      if (leftLanguage.value === 'auto') {
        _message.error('请选择语言');
        return;
      }
      const temp = rightLanguage.value;
      rightLanguage.value = leftLanguage.value;
      leftLanguage.value = temp;
      isChoosed.value = true;
    }
    function onKeyEnter() {
      startTranslation();
    }
    function inputChange() {
      if (inInput.value) {
        clearTimeout(inputTimer);
      }
      inputTimer = setTimeout(() => {
        inInput.value = false;
        rightLanguageIsChoosed.value = false;
        startTranslation();
        clearTimeout(inputTimer);
      }, 2000);
    }
    /** 开始翻译 */
    // eslint-disable-next-line
    function startTranslation() {
      if (!translateOrigin.value) {
        return;
      }
      if (isTranslating.value) {
        return;
      }
      translateResult.value = [];
      // 识别语种
      const form1 = new FormData();
      form1.append('text', translateOrigin.value);
      httpPost(LANGUAGE_IDENTIFICATION_URL, form1).then(res => {
        const data = res;
        if (data) {
          if (!isChoosed.value) {
            leftLanguage.value = data;
          } else if (leftLanguage.value !== data) {
            identifyLanguage.value = data;
            showMessage.value = true;
          } else {
            console.log(res);
          }
          const lan = LANGUAGE_ENGLISH_MAP.get(data);
          // 待测试
          if (isChoosed.value && data === leftLanguage.value) {
            showMessage.value = false;
          }
        }
        checkDomainDisabled();
        isTranslating.value = true; // 正在翻译
        const appId = '0E2F264CBF8C4262A120221220203941';
        const appKey = 'C4EE592935D268D6332A3F97947D9DD6';
        const param = JSON.stringify({
          appId,
          domain: tranDomain.value,
          from: leftLanguage.value,
          to: rightLanguage.value,
          textList: translateOrigin.value.split('\n')
        });
        const ts = new Date().valueOf();
        const form = new FormData();
        form.append('param', param);
        form.append('secretKey', md5.hex(appKey + param + ts));
        form.append('ts', `${ts}`);
        if (rightLanguage.value === 'ar') {
          rightTextAreaStyle.value.direction = 'rtl';
          rightTextAreaStyle.value.textAlign = 'right';
        } else {
          rightTextAreaStyle.value.direction = 'ltr';
          rightTextAreaStyle.value.textAlign = 'left';
        }
        httpPost(TRANSLATE_URL, form).then(res => {
          if (res) {
            isTranslating.value = false;
            if (res.code !== 0) {
              _message.error('Translation failure');
              return;
            }
            try {
              const result = JSON.parse(res.data).trans_result;
              translateResult.value = result.map(item => item.dst);
            } catch (e) {
              console.error(e);
            }
          } else {
            _message.error('Translation failed. Please try again later');
            isTranslating.value = false;
            translateResult.value = [];
          }
        });
      });
    }
    return {
      LANGUAGE_ENGLISH_MAP,
      switchImg,
      leftLanguage,
      rightLanguage,
      identifyLanguage,
      tranDomain,
      translateOrigin,
      languageInfo,
      translateResult,
      isTranslating,
      isUrl,
      inInput,
      copyTxt,
      isChoosed,
      showMessage,
      leftLanguage2,
      isShowPrivacyTip,
      rightLanguageIsChoosed,
      patentDisabled,
      announcementDisabled,
      leftTextAreaStyle,
      rightTextAreaStyle,
      fromLanguageList,
      toLanguageList,
      fromLanguages,
      toLanguages,
      domains,
      chooseLan,
      chooseRightLan,
      changeLeftLan,
      copy,
      startTranslation,
      exchange,
      onKeyEnter,
      inputChange
    };
  }
});